import axios from "axios";
import { useState } from "react";
import "./LoginPage.css";
import actions from "../redux/actions/userActions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function LoginPage() {
  const [toggleVisibility, setToggleVisibility] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [apiStatus, setApiStatus] = useState(0);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data, e) => {
    e.preventDefault();
    try {
      const response = await toast.promise(
        axios({
          method: "POST",
          url: process.env.REACT_APP_API_URL + "/api/admins/tokens",
          data: data,
        }),
        {
          pending: "Validating credentials...",
          success: "Successfully logged",
          error: "Invalid credentials",
        }
      );
      dispatch(actions.login(response.data));
      setTimeout(navigate, 1500, "/");
    } catch (error) {
      if (error.status === 401) {
        alert("Ups!, algo ha salido mal.");
      } else {
        setApiStatus(error.response.status);
      }
    }
  };
  return (
    <div className="container-fluid animate__animated animate__fadeIn d-flex flex-column login-page h-100">
      <div className="row justify-content-center pt-5">
        <div className="col-3 login-form bg-dark p-5 login-shadow">
          <h1 className="text-white fw-light fs-4 text-center">ADMIN PANEL</h1>

          {apiStatus && (
            <p className="text-danger text-center fw-bold">
              Incorrect Email or Password
            </p>
          )}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="input-group mb-3 mt-5">
              <span
                className="input-group-text bg-secondary rounded-0 border-0 login-shadow"
                id="E-mail"
              >
                <i className="bi bi-person-fill text-light fs-4"></i>
              </span>
              <input
                autoComplete="off"
                type="email"
                className="form-control text-white border-0 login-inputs"
                placeholder="E-mail"
                aria-label="E-mail"
                aria-describedby="E-mail"
                defaultValue="admin@admin.com"
                {...register("email", { required: true })}
              />
              {errors.email && (
                <span className="f-roboto fs-7 text-danger">
                  This field is required
                </span>
              )}
            </div>
            <div className="input-group mb-5">
              <span
                onClick={() => setToggleVisibility(!toggleVisibility)}
                className="input-group-text rounded-0 border-0 login-shadow btn-password"
                id="Password"
              >
                {toggleVisibility ? (
                  <i className="bi bi-lock-fill text-light fs-4"></i>
                ) : (
                  <i className="bi bi-unlock-fill text-light fs-4"></i>
                )}
              </span>
              <input
                autoComplete="off"
                type={toggleVisibility ? "password" : "text"}
                className="form-control rounde-0 text-white border-0 login-inputs"
                placeholder="Password"
                aria-label="Password"
                aria-describedby="Password"
                defaultValue="admin1234"
                {...register("password", { required: true })}
              />
              {errors.password && (
                <span className="f-roboto fs-7 text-danger">
                  This field is required
                </span>
              )}
            </div>
            <div className="px-3">
              <button className="btn btn-login w-100 rounded-0 fs-6 px-2 login-shadow">
                LOGIN
              </button>
              <p className="text-secondary mt-3">
                Go to the{" "}
                <a
                  href={`${process.env.REACT_APP_E_COMMERCE_URL}`}
                  className="link"
                >
                  e-commerce
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
      <footer className="footer mt-auto py-3 text-secondary text-center">
        <span className="text-muted">Hack Academy 2022</span>
      </footer>
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default LoginPage;
